module.exports = __webpack_public_path__ + "static/img/logo.90cb3de1.png";